import _ from 'underscore';
import { Subtract } from 'utility-types';

import { FilterUpdaterOwnProps, withFilterUpdater } from '~src/spacesPlatform/components/Explorer/helpers/FilterUpdater';
import { SortOrderUpdaterOwnProps, withSortOrderUpdater } from '~src/spacesPlatform/components/Explorer/helpers/SortOrderUpdater';

import { ConnectedFlowSpace } from './ConnectedFlowSpace';
import { FlowSpaceOwnProps } from './FlowSpace';
import {
  FlowSpaceDataFetcherProps,
  InjectedFlowSpaceDataFetcherProps,
  withFlowSpaceDataFetcher
} from './FlowSpaceDataFetcher';
import {
  FlowSpaceServiceInjectorProps,
  InjectedFlowSpaceServiceInjectorProps,
  withFlowSpaceServiceInjector
} from './FlowSpaceServiceInjector';

export type FlowSpaceProviderProps = FilterUpdaterOwnProps
  & SortOrderUpdaterOwnProps
  & FlowSpaceDataFetcherProps
  & FlowSpaceServiceInjectorProps
  & Subtract<Subtract<FlowSpaceOwnProps, InjectedFlowSpaceDataFetcherProps>, InjectedFlowSpaceServiceInjectorProps>;

export const FlowSpaceProvider: React.ComponentType<FlowSpaceProviderProps> = _.compose(
  withFilterUpdater,
  withSortOrderUpdater,
  withFlowSpaceDataFetcher,
  withFlowSpaceServiceInjector,
)(ConnectedFlowSpace);
